module.exports = __webpack_public_path__ + "static/the-graveyard-book-b793b3f5a6dbad008256fedd9ad41b08.jpg";